"use strict";function e(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var t=e(require("styled-components")).default.button`
  width: 100%;
  display: grid;
  grid-template-columns: 75px 1fr;
  background: ${({theme:e,isElevated:t})=>t?e.colors.light:"transparent"};
  border: solid 1px
    ${({isSelected:e,theme:t})=>e?t.colors.primary.default:"transparent"};
  border-radius: 4px;
  box-shadow: ${({theme:e,isElevated:t,isSelected:o})=>t?o?e.shadows.low:e.shadows.mid:"none"};
  align-items: center;
  grid-column-gap: 12px;
  padding: 11px;
  cursor: pointer;
  /* outline: none; */
  transition: all 0.2s ease-in-out;

  picture {
    width: 100%;
    height: 0;
    padding-top: 100%;
    position: relative;

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: transparent;
      object-fit: cover;
    }
  }

  .content {
    text-align: left;

    p {
      margin: 0;

      &.price {
        color: ${({theme:e})=>e.colors.grey[0]};
      }
    }

    .label {
      .tooltip {
        margin-left: 5px;

        svg {
          vertical-align: middle;
          margin-bottom: 3px;
        }
      }
    }
  }
`;module.exports=t;
//# sourceMappingURL=styles.js.map
